export default __webpack_public_path__ + "static/media/Erica_2.9fca1a8d.webp";